/**
 * 使用常量替代 Mutation 事件类型
 */

// 设置用户信息
export const SET_USER_INFO = 'SET_USER_INFO'
// 设置菜单列表
export const SET_MENUS = 'SET_MENUS'
// 设置当前页面所选菜单路径
export const SET_MENU_URL = 'SET_MENU_URL'
// 清除菜单列表、用户信息、菜单所选路径
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO'
